/* tslint:disable */
/* eslint-disable */

export interface ManualData extends Serializable {
    link: string;
    sections: Record<string, Section>;
    rules: Record<string, Rule>;
    terms: Record<string, Term>;
}

export interface Serializable {
}

export interface Section {
    href: string;
    id: string;
    name: string;
}

export interface Rule {
    id: string;
    href: string;
    headline: string;
    evergreen: boolean;
    violation: string;
}

export interface Term {
    term: string;
    definition: string;
    baseRegex: string;
}

export const enum Program {
    FRC = "FRC",
    FTC = "FTC",
    FLLC = "FLLC",
    FLLE = "FLLE",
    FLL = "FLL",
}
